var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FlexBox, screenClassMinWidths } from '@vp/swan';
import { css, cx } from '@emotion/css';
const styleErrorIconContainer = css `
    width: 100%;
    text-align: center;
`;
const styleErrorIcon = css `
    width: 100%;
    border: none;
    background-color: transparent;
    outline: none;
    max-width: 140px;
    @media only screen and (min-width: ${screenClassMinWidths['sm']}px) {
        max-width: 250px;
    }
`;
const ErrorIcon = (_a) => {
    var { Icon, handleErrorLogoClick, className } = _a, rest = __rest(_a, ["Icon", "handleErrorLogoClick", "className"]);
    return (React.createElement(FlexBox, Object.assign({ className: cx(styleErrorIconContainer, className), flexDirection: "column", alignItems: "center" }, rest),
        React.createElement("button", { "data-testid": "logobutton", className: styleErrorIcon, type: "button", onClick: handleErrorLogoClick }, Icon)));
};
ErrorIcon.displayName = 'ErrorIcon';
export default ErrorIcon;
//# sourceMappingURL=ErrorIcon.js.map